export var localBreadcrumbs = function localBreadcrumbs(strictLocalize) {
  return {
    HOME: strictLocalize({
      id: "zXMIoX",
      defaultMessage: "Home"
    }),
    POPULAR_GUIDES: strictLocalize({
      id: "AuCq+K",
      defaultMessage: "Popular guides"
    }),
    SEARCH: strictLocalize({
      id: "heC0E1",
      defaultMessage: "Search"
    }),
    RETAILER_GUIDES: strictLocalize({
      id: "0uLEFs",
      defaultMessage: "Retailer Guides"
    }),
    BRAND_GUIDES: strictLocalize({
      id: "VAqQy9",
      defaultMessage: "Brand Guides"
    })
  };
};